const DEFAULT_COUNTER_LENGTH = 3;
const CHARACTER_WIDTH = 8;
const CHIP_PADDING = 26;

const getCounterLength = (value: unknown): number => {
  if (typeof value !== 'number' || !Number.isFinite(value) || value < 1) {
    return DEFAULT_COUNTER_LENGTH;
  }

  return String(value).length;
};

export function calcChipSkeletonWidth(label: string, expCountByTag?: Record<string, number> | null): number {
  const counterLength = getCounterLength(expCountByTag?.[label]);

  return (label.length + counterLength) * CHARACTER_WIDTH + CHIP_PADDING;
}

/**
 * Разбивает массив строк тэгов на два ряда для скелетонов рубрик.
 */
export function calcSkeletonWidths(
  tags: string[],
  expCountByTag?: Record<string, number> | null,
): { firstRow: number[]; secondRow: number[] } {
  const widths = tags.map((tag) => calcChipSkeletonWidth(tag, expCountByTag));
  const midpoint = Math.ceil(widths.length / 2);

  return {
    firstRow: widths.slice(0, midpoint),
    secondRow: widths.slice(midpoint),
  };
}
